var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting_main_contents", attrs: { id: "job-main-content" } },
    [
      _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
        _c("i", { class: { loadding_setting: _vm.isLoadingData } })
      ]),
      _c("div", { staticClass: "setting_heading" }, [
        _c("h1", { staticClass: "setting_heading_title" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.jobInformationProperty.TAB_HEADER) +
              "\n    "
          )
        ]),
        _c("p", { staticClass: "setting_heading_explain" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.jobInformationProperty.SUB_HEADER) +
              "\n    "
          )
        ])
      ]),
      _c("div", { staticClass: "setting_tab" }, [
        _c("div", { staticClass: "setting_tab_nav" }, [
          _c("ul", { staticClass: "setting_tab_nav_list" }, [
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item is_active",
                attrs: { id: "t1" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(1)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.jobInformationProperty.JOB_INFORMATION_TAB_TITLE
                      ) +
                      "\n          "
                  )
                ])
              ]
            )
          ])
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.JOB_INFORMATION_TAB,
                expression: "navTab === JOB_INFORMATION_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("JobInformationTab", {
                  on: {
                    updateRedisData: _vm.updateRedisData,
                    resetMasterData: _vm.resetMasterData
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c("div", { staticClass: "setting_footer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }